import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerAreaContainerComponent } from '../../containers/customer-area-container/customer-area-container.component';
import { LoginComponent } from './components/login/login.component';
import { LinesListComponent } from '../lines/components/lines-list/lines-list.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ResetLoginComponent } from './components/reset-login/reset-login.component';
import { FirstConnexionComponent } from './components/first-connexion/first-connexion.component';

const routes: Routes = [
  {
    path: '', component: CustomerAreaContainerComponent,
    children: [
      { path: 'connexion/:token/:expiration/:session/:support_id', component: LoginComponent },
      { path: 'connexion/:msisdn', component: LoginComponent },
      { path: 'connexion/:token/:expiration/:session/:id/:email/:isAdminProFleet', component: LoginComponent },
      { path: 'connexion/:callbackUrl', component: LoginComponent },
      { path: 'connexion', component: LoginComponent },
      { path: 'premiere-connexion', pathMatch: 'full', component: FirstConnexionComponent },
      { path: 'oubli-mdp', pathMatch: 'full', component: ForgotPasswordComponent },
      { path: 'nouvel-email', pathMatch: 'full', component: ResetLoginComponent },
      { path: 'reinitialiser-mdp/:token', component: ResetPasswordComponent },
      { path: 'lignes', component: LinesListComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
